module.exports = __webpack_public_path__ + "img/20190910161049528.42a17b43.jpg";